"use client";

import { ComponentProps } from "react";
import { useRive, Fit, Layout, Alignment } from "@rive-app/react-canvas";

interface RiveAnimationProps {
  /** Path/URL to the .riv file (e.g. "/rive/hero.riv" from /public). */
  src: string;
  /** Name of the state machine to play. */
  stateMachine?: string;
  /** Name of a specific animation (use instead of stateMachine for simple loops). */
  animation?: string;
  /** Whether the animation starts playing automatically. Defaults to true. */
  autoplay?: boolean;
  /** How the artboard fits its container. Defaults to Fit.Contain. */
  fit?: Fit;
  /** className applied to the canvas wrapper — set width/height here. */
  className?: string;
}

export default function RiveAnimation({
  src,
  stateMachine,
  animation,
  autoplay = true,
  fit = Fit.Contain,
  className,
}: RiveAnimationProps) {
  const { RiveComponent } = useRive({
    src,
    stateMachines: stateMachine,
    animations: animation,
    autoplay,
    layout: new Layout({ fit, alignment: Alignment.Center }),
  });

  return <RiveComponent className={className} />;
}

export type { RiveAnimationProps };
export { Fit, Alignment };
